import { render, staticRenderFns } from "./MoneyAccounts.vue?vue&type=template&id=231a8779&"
import script from "./MoneyAccounts.vue?vue&type=script&lang=js&"
export * from "./MoneyAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports